import { render, staticRenderFns } from "./KnDocsGalleryItem.vue?vue&type=template&id=78d668d4&scoped=true&"
import script from "./KnDocsGalleryItem.vue?vue&type=script&lang=js&"
export * from "./KnDocsGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./KnDocsGalleryItem.vue?vue&type=style&index=0&id=78d668d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d668d4",
  null
  
)

export default component.exports